export default __webpack_public_path__ + "static/media/virtualDom.a31cd98f.png";